<template>
  <v-card v-if="!loading" flat>
    <v-card-text class="mb-3 pb-0">
      <p><strong>Formavimo parametrai</strong></p>
      <v-row>
        <v-col cols="12" md="12">
          <dl>
            <dt>Padalinys</dt>
            <dd>
              {{ padaliniaiText }}
            </dd>
          </dl>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'NaikinimasArchyvarasParametrai',
  props: {
    parametrai: Array,
    loading: Boolean,
  },
  data: () => ({
    paslauga: null,
  }),
  computed: {
    padaliniaiText() {
      return this.parametrai.join(', ')
    },
  },
  methods: {
    //
  },
}
</script>
<style lang="scss" scoped>
dt {
  font-weight: 400;
}
dd {
  margin-bottom: 10px;
  padding-top: 2px;
  padding-bottom: 5px;
  min-height: 27px;
  font-weight: 600;
  border-bottom: 1px solid rgba(0, 0, 0, 0.57);
}
</style>
